export type ContentType =
  | 'Article'
  | 'Course Challenge'
  | 'Exercise'
  | 'Lesson'
  | 'TopicQuiz'
  | 'TopicUnitTest'
  | 'Video'
  | 'Meeting'
  | 'Supporting';

/**
 * Determine the type of content based on the URL.
 * @param url - The URL of the content.
 * @returns The type of content ('Video' or 'Article' or 'Course Challenge' or 'Exercise' or 'Lesson' or 'TopicQuiz' or 'TopicUnitTest' or 'Meeting').
 */
export function getContentType(url: string): ContentType {
  if (!url) {
    return 'Lesson'; // Default content type if URL is null or undefined
  }
  const patterns = {
    Video: ['youtu.be', 'youtube', 'showVideoDirectly=true', '/v/'],
    Article: ['/a/', '/info'],
    TopicUnitTest: ['/test/', 'unit-test'],
    TopicQuiz: ['/quiz/', '-quiz-'],
    Exercise: ['/e/'],
    'Course Challenge': ['course-challenge'],
    Meeting: ['calendly.com'],
    Supporting: ['cms.academics.alpha.school'],
  };

  for (const [type, typePatterns] of Object.entries(patterns)) {
    for (const pattern of typePatterns) {
      if (url.includes(pattern)) {
        return type as ContentType;
      }
    }
  }

  return 'Lesson';
}

export const checkIfEmbedableLink = (url: string) =>
  url.includes('youtu.be') || url.includes('www.youtube.com');

export const generateEmbedLink = (url: string) => {
  // If it's already an embed URL, return it as is
  if (url.includes('youtube.com/embed/')) {
    return url;
  }

  // Extract video ID from different URL formats
  const videoId = url.includes('youtu.be/')
    ? url.split('youtu.be/')[1]
    : url.split('v=')[1]?.split('&')[0]; // Handle any URL parameters after video ID

  return `https://www.youtube.com/embed/${videoId}`;
};
